import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastDay(props) {
  function maximumTemperature() {
    const temperature = Math.round(props.data.temperature.maximum);
    return `${temperature}°`;
  }

  function minimumTemperature() {
    const temperature = Math.round(props.data.temperature.minimum);
    return `${temperature}°`;
  }

  function day() {
    const date = new Date(props.data.time * 1000);
    const dayIndex = date.getDay();
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return days[dayIndex];
  }

  return (
    <div>
      <div className="WeatherForecast-day">{day()}</div>
      <div className="WeatherForecast-icon">
        <WeatherIcon code={props.data.condition.icon} size={36} />
      </div>
      <div className="WeatherForecast-temperatures">
        <span className="WeatherForecast-temperatures-max">
          {maximumTemperature()}
        </span>
        <span className="WeatherForecast-temperatures-min">
          {minimumTemperature()}
        </span>
      </div>
    </div>
  );
}
